import React, { PureComponent } from 'react'

export default class IconYoutube extends PureComponent {
	render() {
		return (
			<svg width="29" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M28.2 7.3a3.5 3.5 0 0 0-2.5-2.5c-2.2-.6-11-.6-11-.6s-8.7 0-10.9.6a3.5 3.5 0 0 0-2.5 2.5C.8 9.5.8 14 .8 14s0 4.6.5 6.8a3.5 3.5 0 0 0 2.5 2.4c2.2.6 11 .6 11 .6s8.7 0 10.9-.6a3.5 3.5 0 0 0 2.5-2.4c.6-2.2.6-6.8.6-6.8s0-4.5-.6-6.7zM11.9 18.2V9.9l7.3 4.1-7.3 4.2z"
					fill="#575757"
				/>
			</svg>
		)
	}
}
